import { render, staticRenderFns } from "./Freigabe.vue?vue&type=template&id=c75c83c4&scoped=true"
import script from "./Freigabe.vue?vue&type=script&lang=ts"
export * from "./Freigabe.vue?vue&type=script&lang=ts"
import style0 from "./Freigabe.vue?vue&type=style&index=0&id=c75c83c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75c83c4",
  null
  
)

export default component.exports